module.exports = __webpack_public_path__ + "img/有猿医家山河医学网APP下载二维码.b00f7779.png";